export default __webpack_public_path__ + "static/media/foody.a96afb82.png";